import { LINKEDIN_AUTOMATION_STAGE_STATUSES } from './linkedinAutomationStageStatuses'
import { statusVisibilityUrl } from './linkedinUrls'
import {
  getCurrentValueForRadioButtons,
  saveCurrentValueForRadioButtons,
  toggleRadioButton,
} from './radioButtonUtils'
import { LinkedinSettingKey } from '../../recommendations/recommendationSettingsKeys'
import { LinkedinRecommendationKey, StageType } from '../../utils/enums'
import { StageDef } from '../automationMachineInterfaces'
import {
  defaultCantUndoFn,
  defaultIsDisabledFn,
  defaultIsDisabledReasonFn,
  getCurrentValueFnFromKey,
  getIsFulfilledFnFromKey,
} from '../recommendationCardDisplayUtils'

const STATUS_VISIBILITY_SETTINGS = {
  NO_ONE: 'No one',
  CONNECTIONS_ONLY: 'Your Connections only',
  ANYONE: 'All LinkedIn members',
}

// Setting property functions
const getCurrentValueFn = (key) =>
  getCurrentValueFnFromKey(key, (value) => value)

const getIsFulfilledFn = (key) =>
  getIsFulfilledFnFromKey(
    key,
    (value) => value === STATUS_VISIBILITY_SETTINGS.NO_ONE,
  )

const getCantUndoFn = () => defaultCantUndoFn
const getIsDisabledFn = () => defaultIsDisabledFn
const getIsDisabledReasonFn = () => defaultIsDisabledReasonFn

// Automations

enum StageKey {
  LINKEDIN_STATUS_VISIBILITY_GATHER = 'LINKEDIN_STATUS_VISIBILITY_GATHER',
  LINKEDIN_STATUS_VISIBILITY_UPDATE = 'LINKEDIN_STATUS_VISIBILITY_UPDATE',
  LINKEDIN_STATUS_VISIBILITY_UNDO = 'LINKEDIN_STATUS_VISIBILITY_UNDO',
}

const gatherStageDefs: StageDef[] = [
  {
    type: StageType.ACTION,
    key: StageKey.LINKEDIN_STATUS_VISIBILITY_GATHER,
    status: LINKEDIN_AUTOMATION_STAGE_STATUSES.GATHERING_SETTINGS,
    url: statusVisibilityUrl,
    action: async (machineContext, userContext) => {
      await saveCurrentValueForRadioButtons(
        userContext.updateStoredInitialValues,
        STATUS_VISIBILITY_SETTINGS,
        LinkedinSettingKey.STATUS_VISIBILITY,
        LinkedinRecommendationKey.LINKEDIN_STATUS_VISIBILITY,
      )
    },
  },
]

const updateStageDefs: StageDef[] = [
  {
    type: StageType.ACTION,
    key: StageKey.LINKEDIN_STATUS_VISIBILITY_UPDATE,
    status: LINKEDIN_AUTOMATION_STAGE_STATUSES.UPDATING_SETTINGS,
    url: statusVisibilityUrl,
    action: async (machineContext, userContext) => {
      const { isDry } = userContext

      const currentSetting = await getCurrentValueForRadioButtons(
        STATUS_VISIBILITY_SETTINGS,
      )

      if (!(currentSetting === STATUS_VISIBILITY_SETTINGS.NO_ONE) && !isDry) {
        return toggleRadioButton(STATUS_VISIBILITY_SETTINGS.NO_ONE)
      }
      return null
    },
  },
]

const undoStageDefs: StageDef[] = [
  {
    type: StageType.ACTION,
    key: StageKey.LINKEDIN_STATUS_VISIBILITY_UNDO,
    status: LINKEDIN_AUTOMATION_STAGE_STATUSES.UPDATING_SETTINGS,
    url: statusVisibilityUrl,
    action: async (machineContext, userContext) => {
      const { initialValues, isDry } = userContext

      const currentSetting = getCurrentValueForRadioButtons(
        STATUS_VISIBILITY_SETTINGS,
      )

      // Toggle setting if checkbox does not match initial values
      if (
        initialValues?.[LinkedinSettingKey.STATUS_VISIBILITY] !==
          currentSetting &&
        !isDry
      ) {
        return toggleRadioButton(
          initialValues[LinkedinSettingKey.STATUS_VISIBILITY],
        )
      }
      return null
    },
  },
]

export {
  getCantUndoFn,
  getCurrentValueFn,
  getIsDisabledFn,
  getIsDisabledReasonFn,
  getIsFulfilledFn,
  gatherStageDefs,
  updateStageDefs,
  undoStageDefs,
}
